import styled from 'styled-components';

export const Card = styled.div`
  position: relative;
  svg {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    color: #fff;
    font-size: 60px;
  }
`;

export const Title = styled.h3`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Figure = styled.figure`
  border-radius: 10.04px;
  overflow: hidden;
  margin-bottom: 16px;
  position: relative;
  img {
    width: 100%;
  }
`;

export const PublishedAt = styled.p`
  font-size: 10px;
  line-height: 14px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const AuthorName = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: 400;
`;

export const AuthorImage = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;
  object-fit: cover;
`;

export const Author = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;
